<template>
  <section class="parts-container" :class="[$style.parts_container, { [$style.lpnh]: pageType === 'lpnh' }]">
    <div :class="$style.thumb">
      <div v-if="url">
        <AtomsConsumerLink :url="url" :class="$style.link">
          <AtomsConsumerImage
            v-if="imgUrl"
            :src="imgUrl"
            :alt="imgUrlCaption ? imgUrlCaption : ''"
            :class="{ 'page-parts-pc': spImgUrl || displayType === 'pc' }"
            :width="1280"
            @click="trackBannerClick('image', imgUrl, 0, imgUrlCaption ?? '')"
          />
          <AtomsConsumerImage
            v-if="spImgUrl"
            :src="spImgUrl"
            :alt="spImgUrlCaption ? spImgUrlCaption : ''"
            class="page-parts-sp"
            :width="windowWidth > 768 ? 768 : windowWidth"
            @click="trackBannerClick('image', spImgUrl, 0, spImgUrlCaption ?? '')"
          />
        </AtomsConsumerLink>
      </div>
      <div v-else>
        <AtomsConsumerImage
          v-if="imgUrl"
          :src="imgUrl"
          :alt="imgUrlCaption ? imgUrlCaption : ''"
          :class="{ 'page-parts-pc': spImgUrl || displayType === 'pc' }"
          :width="1280"
        />
        <AtomsConsumerImage
          v-if="spImgUrl"
          :src="spImgUrl"
          :alt="spImgUrlCaption ? spImgUrlCaption : ''"
          class="page-parts-sp"
          :width="windowWidth > 768 ? 768 : windowWidth"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { DisplayType } from "@tential/ec-gql-schema/master/pageParts"
type Props = {
  url?: string
  imgUrlCaption?: string
  spImgUrlCaption?: string
  imgUrl: string
  spImgUrl?: string
  displayType?: DisplayType
  pageType?: string
}

withDefaults(defineProps<Props>(), {
  url: "",
  imgUrlCaption: "",
  spImgUrlCaption: "",
  imgUrl: "",
  spImgUrl: "",
  displayType: "all",
  pageType: "",
})

const { trackBannerClick } = useGtagEvent()
const { width: windowWidth } = useWindowSize()
</script>

<style scoped module lang="scss">
.parts_container {
  @include container-lg;
  .thumb {
    width: 100%;
    overflow: hidden;
    .link {
      cursor: pointer;
    }
    img {
      width: 100%;
      object-fit: contain;
      border-radius: 0.375rem;
    }
  }
  &.lpnh {
    @include full-container-lg;
    img {
      border-radius: 0;
    }
  }
}
</style>
